/* eslint-disable react-hooks/exhaustive-deps */
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styled from "styled-components";
import { Box, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { TablePagination } from '../../components/pagination/Pagination';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from "react-hook-form";
import { LoadingButton } from '@mui/lab';
import SingleInputDateRangePicker from '../../components/dateRange/DateRange';
import * as XLSX from 'xlsx';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { AccountTypes } from '../customer/CustomerConstants';
import CustomSelect from '../../components/forms/select/CustomSelect';
import moment from 'moment';

export const TableCellHeading = styled(TableCell)`
    font-weight: 700 !important;
    min-width:${(props: any): string => props.minwidth ? props.minwidth : '60px'};
    padding:
`;

export default function CustomerListReports() {

    const [customers, setCustomers] = useState<any | null>();
    const [count, setCount] = useState<any>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const [showApproved,] = useState<string>('true');
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(10)
    const initialValues = { mobileNo: "", accountNo: "", name: "", lockerNo: "", isMainTable: showApproved, toDate: null, fromDate: null, isExpired: 'false' }

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({ defaultValues: initialValues })
    const { get } = useCrudForm();

    const fetchData = ({ toDate, fromDate, name, mobileNo, lockerNo, accountNo, isMainTable, isExpired }: { fromDate?: string, toDate?: string, name?: string, accountNo?: string, lockerNo?: string, mobileNo?: string, isMainTable?: string, isExpired?: string }) => {
        setLoading(true)
        get({
            endpoints: endpoints.customer.list({ skip: skip * take, take: take, name: name, accountNo: accountNo, lockerNo: lockerNo, mobileNo: mobileNo, isMainTable: isMainTable, fromDate: fromDate, toDate: toDate, isExpired: isExpired }),
            onSuccess: (data: any) => {
                setCustomers(data.data.list)
                setCount(data.data.count)
                setButtonLoading(false)
                setLoading(false)
            },
            onError: (error: any) => {
                setCustomers([])
                setLoading(false)
                setButtonLoading(false)
            }
        })
    }

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        fetchData({ fromDate: values?.fromDate, toDate: values?.toDate, name: values?.name, accountNo: values?.accountNo, lockerNo: values?.lockerNo, mobileNo: values?.mobileNo, isMainTable: showApproved, isExpired: values?.isExpired })
    };

    const resetSearch = () => {
        setValue("name", '');
        setValue("accountNo", '');
        setValue("lockerNo", '');
        setValue("mobileNo", '');
        setValue("toDate", null);
        setValue("fromDate", null);
        setValue("isMainTable", 'true');
        setValue("isExpired", 'false');
        setLoading(true)
        fetchData({ isMainTable: showApproved, isExpired: 'false' })
    };
    const lockerList = (lockers: any) => lockers.map((locker: any, index: number) => <Typography key={index} style={{ fontSize: "12px" }}>{locker.lockerNumber}</Typography>)
    const lockerExpiryList = (lockers: any) => lockers.map((locker: any, index: number) => <Typography key={index} style={{ fontSize: "12px" }}>{locker.expiryDate}</Typography>)


    useEffect(() => {
        fetchData({
            name: getValues()?.name,
            accountNo: getValues()?.accountNo,
            lockerNo: getValues()?.lockerNo,
            mobileNo: getValues()?.mobileNo,
            isMainTable: showApproved,
            isExpired: getValues()?.isExpired,
        })
    }, [skip, take])

    const handleDownload = () => {
        setExportLoading(true)
        get({
            endpoints: endpoints.customer.list({
                fromDate: getValues()?.fromDate,
                toDate: getValues()?.toDate,
                isExport: true,
                name: getValues()?.name,
                accountNo: getValues()?.accountNo,
                lockerNo: getValues()?.lockerNo,
                mobileNo: getValues()?.mobileNo,
                isMainTable: showApproved,
                isExpired: getValues()?.isExpired
            }),
            onSuccess: (data: any) => {
                const excelData = data.data?.list && data.data?.list.length > 0 ? data.data.list.map((cus: any, index: number) => [
                    index + 1,
                    AccountTypes[cus.accountType],
                    cus.accountNumber,
                    cus.fullName,
                    cus?.mobileNumber,
                    cus?.customerLockers?.map((loc: any) => loc?.lockerNumber).join(","),
                    cus?.isBiometricTaken ? 'yes' : 'No',
                    cus?.isActive ? 'Active' : 'InActive',
                    moment(cus?.createdDate).format('YYYY-MM-DD'),
                    cus?.customerLockers?.map((loc: any) => loc?.expiryDate).join(",")
                ]) : []
                const headers = ["S.N", "Account Type", "Account No.", "FullName", "Mobile", "Lockers", "Fingerprint ?", "Status", 'Created Date', 'Expiry Date']
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(excelData);
                worksheet['!cols'] = [
                    { wch: 5 },
                    { wch: 20 },
                    { wch: 25 },
                    { wch: 20 },
                    { wch: 18 },
                    { wch: 20 },
                    { wch: 10 },
                    { wch: 8 },
                    { wch: 8 },
                    { wch: 25 },
                ];
                XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
                XLSX.utils.sheet_add_aoa(worksheet, [headers]);
                const name = showApproved === 'true' ? 'ApprovedCustomerList.xlsx' : 'NeedToApprovedCustomerList.xlsx'
                XLSX.writeFile(workbook, name, { compression: true });
                setExportLoading(false)
            },
            onError: (error: any) => setExportLoading(false)
        })
    };

    return (<Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Customer</Typography>
        <form>
            <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'start', marginBottom: "24px" }}>
                <Grid item  >
                    <ControlledInput width={"150px"} name="mobileNo" control={control} errors={errors} label="Mobile" size={'small'} />
                </Grid>
                <Grid item >
                    <ControlledInput width={'180px'} name="accountNo" control={control} errors={errors} label="Account number" size={'small'} />
                </Grid>
                <Grid item >
                    <ControlledInput width={'160px'} name="name" control={control} errors={errors} label="Name" size={'small'} />
                </Grid>
                <Grid item >
                    <ControlledInput width={'150px'} name="lockerNo" control={control} errors={errors} label="Locker number" size={'small'} />
                </Grid>
                <SingleInputDateRangePicker control={control} errors={errors} setValue={setValue} getValues={getValues} />
                <Grid item xs={2}>
                    <CustomSelect height='2.5rem' label="Expired?" name="isExpired" errors={errors?.isExpired?.message} control={control} values={[{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }]} size={12} setValue={setValue} />
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'right' }}>
                    <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Reset</LoadingButton>
                    <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} ><Search /></LoadingButton>
                    <LoadingButton loading={exportLoading} onClick={() => handleDownload()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        <CloudDownloadIcon />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Export</Typography>
                    </LoadingButton>
                </Grid>
            </Grid>
        </form>

        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableHeadCell minwidth='40px'>S.N</TableHeadCell>
                            <TableHeadCell align="left" minwidth='130px'>
                                Account Type
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth='150px'>
                                Account No.
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth='160px'>
                                FullName
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth='100px'>
                                Mobile
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth='80px'>
                                Lockers
                            </TableHeadCell>
                            <TableHeadCell align="center" minwidth='125px'>
                                Fingerprint ?
                            </TableHeadCell>
                            <TableHeadCell align="center" minwidth='70px'>
                                Status
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth='150px'>
                                Created Date
                            </TableHeadCell>
                            <TableHeadCell align="center" minwidth='100px'>
                                Expiry Date
                            </TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!customers || loading ? <TableRowsLoader rowsNum={5} colNum={10} />
                            : customers && customers?.length <= 0 ? <TableRow>
                                <TableCell colSpan={10} align='center'>No Data Found</TableCell>
                            </TableRow> : customers?.map((row: any, index: number) => (
                                <Tooltip sx={{ backgroundColor: '#121212' }} title={
                                    <Box>
                                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                            <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                                            </Box>
                                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By: {row?.createdUsername ?? "N/A"}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                            <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                                            </Box>
                                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By: {row?.updatedUsername ?? "N/A"}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                            <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                                            </Box>
                                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By: {row?.verifiedUsername ?? "N/A"}</Typography>
                                        </Box>
                                    </Box>
                                } placement="bottom" arrow key={index}>
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, ":hover": { backgroundColor: '#E3E3E3' } }}
                                    >
                                        <TableCell style={{ fontSize: "12px" }}>   {skip > 0 ? skip * take + index + 1 : index + 1}   </TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{AccountTypes[row.accountType]}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.accountNumber}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{`${row?.firstName}  ${row?.middleName ?? ""}  ${row?.lastName}`}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.mobileNumber}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row?.customerLockers?.length > 0 ? lockerList(row?.customerLockers) : "N/A"}</TableCell>
                                        <TableCell align="center" style={{ fontSize: "12px" }}>{row?.isBiometricTaken ? 'YES' : 'NO'}</TableCell>
                                        <TableCell align="center">     {row.isActive ? 'Active' : 'InActive'}    </TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row?.createdDate ? moment(row?.createdDate).format('YYYY-MM-DD') : 'N/A'}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row?.customerLockers?.length > 0 ? lockerExpiryList(row?.customerLockers) : "N/A"}</TableCell>
                                    </TableRow>
                                </Tooltip>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {customers && (customers?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>
    </Box>
    );
}
